<!-- Card account details -->
<div class="m-b-10">
  <div ng-if="accounts.selectedAccount.hasOwnProperty('balance')">
    <span class="account-header-value white-text-block"
          ng-bind="(accounts.selectedAccount.balance | number:2) + ' ' + (accounts.selectedAccount.currencySymbol)"></span>
    <hr class="account-header-line"/>
    <span class="m-t-neg-15 white-text-block" translate="accounts.accBalance"></span>
  </div>
  <div ng-if="!accounts.selectedAccount.hasOwnProperty('balance') && APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl'">
    <span class="account-header-value white-text-block">
      {{0 | number:2 }} {{accounts.selectedAccount.currencySymbol}}
    </span>
    <hr class="account-header-line"/>
    <span class="m-t-neg-15 white-text-block" translate="accounts.accBalance"></span>
  </div>
  <div class="row account-header-bottom" ng-show="!accounts.isAccountDetailsOpen"
       ng-class="{'m-b-40': !accounts.selectedAccount.hasOwnProperty('availableBalance')}">
    <div ng-if="accounts.selectedAccount.hasOwnProperty('availableBalance')" class="col-xs-12 col-md-4">
      <span class="f-20 white-text-block">
      {{accounts.selectedAccount.availableBalance | number:2}}
      {{accounts.selectedAccount.currencySymbol}}</span>
      <span class="white-text-block" translate="accounts.accAvailableToSpend"></span>
    </div>
  </div>

  <span ng-show="accounts.isAccountDetailsOpen && APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl'">
    <div class="row p-t-20">
     <div class="col-xs-6 col-md-6 p-b-20" ng-if="accounts.selectedAccount.iban">
      <span class="f-20  white-text-block">{{accounts.selectedAccount.iban}}</span>
      <!--<span class="white-text-block" translate="accounts.accountNumber"></span>-->
    </div>
    </div>

    <div class="row p-t-20">
    <!--<div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.cardAccount.cardAccountType">-->
      <!--<span class="f-20 white-text-block">{{accounts.selectedAccount.cardAccount.cardAccountType}}</span>-->
    <!--</div>-->
     <!--<div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.accountNumber">-->
      <!--<span class="f-20  white-text-block">-->
        <!--{{accounts.selectedAccount.accountNumber}}</span>-->
      <!--<span class="white-text-block" translate="accounts.accountNumber"></span>-->
    <!--</div>-->

    <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.status">
      <span class="f-20  white-text-block">
        {{'accounts.'+accounts.selectedAccount.status | translate}}</span>
      <span class="white-text-block" translate="ebook.status"></span>
    </div>

    <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.balanceLastChangedDate">
      <span
        class="f-20 white-text-block">{{accounts.selectedAccount.balanceLastChangedDate | date:'shortDate'}}</span>
      <span class="white-text-block" translate="accounts.accBalanceDateLastChanged"></span>
    </div>

    <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.cardAccount.closingBalanceDate">
      <span class="f-20  white-text-block">
        <!--{{accounts.selectedAccount.balanceLastChangedDate | date:'shortDate'}}</span>-->
        {{accounts.selectedAccount.cardAccount.closingBalanceDate | date:'shortDate'}}</span>
      <span class="white-text-block" translate="accounts.accDateLastChanged"></span>
    </div>
    </div>
  </span>

  <div ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">

    <div class="row p-t-20" ng-switch-when="sl" ng-show="accounts.isAccountDetailsOpen">

      <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.cardAccount.interestRateAmount">
        <span class="f-20 white-text-block">{{accounts.selectedAccount.cardAccount.interestRateAmount}} %</span>
        <span class="white-text-block" translate="accounts.interestRate"></span>
      </div>
      <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.cardAccount.payDate">
        <span class="f-20 white-text-block">{{accounts.selectedAccount.cardAccount.payDate | date: 'dd.'}}</span>
        <span class="white-text-block" translate="accounts.accDueDate"></span>
      </div>
      <div class="col-xs-12 col-md-4 p-b-20"  ng-hide="!accounts.selectedAccount.hasOwnProperty('limit') && APP_GLOBAL_SETTINGS.defaultData.APILocation == 'bh'">
      <span class="f-20 white-text-block">
        <span ng-if="accounts.selectedAccount.hasOwnProperty('limit')">{{accounts.selectedAccount.limit | currency:""}} {{::accounts.selectedAccount.currencySymbol}}</span>
        <span ng-if="!accounts.selectedAccount.hasOwnProperty('limit')" translate="accounts.dataNotAvailable"></span>
      </span>
        <span class="white-text-block" translate="accounts.accBalanceSlo"></span>
      </div>
      <div class="col-xs-12 col-md-4 p-b-20" ng-if="accounts.selectedAccount.cardAccount.obligationAmount">
        <span class="f-20  white-text-block">{{accounts.selectedAccount.cardAccount.obligationAmount | number:2}}</span>
        <span class="white-text-block" translate="accounts.accObligationAmount"></span>
      </div>
      <div class="col-xs-12 col-md-4 p-b-20"
           ng-if="accounts.selectedAccount.cardAccount.outstandingAmount && accounts.selectedAccount.accountType.id === 'VISA'">
        <span
          class="f-20  white-text-block">{{accounts.selectedAccount.cardAccount.outstandingAmount  | number:2}}</span>
        <span class="white-text-block" translate="accounts.accOutstandingAmount"></span>
      </div>

      <div class="col-xs-12 col-md-4 p-b-20" ng-if="accounts.selectedAccount.cardAccount.hasOwnProperty('limitAmountAvailable')">
             <span class="f-20  white-text-block">
               {{accounts.selectedAccount.cardAccount.limitAmountAvailable | number:2}}
               {{accounts.selectedAccount.currencySymbol}}</span>
        <span class="white-text-block" translate="accounts.accPosPaymentLimit"></span>
      </div>

      <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.balanceLastChangedDate">

        <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.limitValidUntilDate">
      <span class="f-20  white-text-block">
        {{accounts.selectedAccount.limitValidUntilDate | date:'shortDate'}}</span>
          <span class="white-text-block" translate="accounts.accLimitValidUntilDate"></span>
        </div>
      </div>
      </div>

      <div class="row p-t-20" ng-switch-default ng-show="accounts.isAccountDetailsOpen">

        <div class="col-xs-12 col-md-4 p-b-20" ng-hide="!accounts.selectedAccount.hasOwnProperty('limit') && APP_GLOBAL_SETTINGS.defaultData.APILocation == 'bh'">
      <span class="f-20 white-text-block">
        <span ng-if="accounts.selectedAccount.hasOwnProperty('limit')">{{accounts.selectedAccount.limit | currency:""}} {{::accounts.selectedAccount.currencySymbol}}</span>
        <span ng-if="!accounts.selectedAccount.hasOwnProperty('limit')" translate="accounts.dataNotAvailable"></span>
      </span>
          <span class="white-text-block" translate="accounts.accApprovedLimit"></span>
        </div>

        <!--<div class="col-xs-12 col-md-4 p-b-20" ng-if="accounts.selectedAccount.cardAccount.payDate">-->
        <!--<span class="f-20  white-text-block">{{accounts.selectedAccount.cardAccount.payDate | date:'shortDate'}}</span>-->
        <!--<span class="white-text-block" translate="accounts.accDueDate"></span>-->
        <!--</div>-->
        <div class="col-xs-12 col-md-4 p-b-20" ng-if="accounts.selectedAccount.cardAccount.obligationAmount">
          <span
            class="f-20  white-text-block">{{accounts.selectedAccount.cardAccount.obligationAmount | currency: ""}} {{::accounts.selectedAccount.currencySymbol}}</span>
          <span class="white-text-block" translate="accounts.accObligationAmount"></span>
        </div>
        <div class="col-xs-12 col-md-4 p-b-20"
             ng-if="accounts.selectedAccount.cardAccount.outstandingAmount && accounts.selectedAccount.accountType.id === 'VISA'">
        <span
          class="f-20  white-text-block">{{accounts.selectedAccount.cardAccount.outstandingAmount  | number:2}}</span>
          <span class="white-text-block" translate="accounts.accOutstandingAmount"></span>
        </div>
        <!--   <div class="col-xs-12 col-md-4 p-b-20" ng-if="accounts.selectedAccount.cardAccount.limitAmountAtm">
             <span class="f-20  white-text-block">
               {{accounts.selectedAccount.cardAccount.limitAmountAtm | number: 2 }}
               {{accounts.selectedAccount.currencySymbol}}</span>
             <span class="white-text-block" translate="accounts.accAtmWithdrawalLimit"></span>
           </div>

           <div class="col-xs-12 col-md-4 p-b-20" ng-if="accounts.selectedAccount.cardAccount.limitAmountAvailable">
             <span class="f-20  white-text-block">
               {{accounts.selectedAccount.cardAccount.limitAmountAvailable |number:2}}
               {{accounts.selectedAccount.currencySymbol}}</span>
             <span class="white-text-block" translate="accounts.accPosPaymentLimit"></span>
           </div>-->
        <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.status">
      <span class="f-20  white-text-block">
        {{'accounts.'+accounts.selectedAccount.status | translate}}</span>
          <span class="white-text-block" translate="ebook.status"></span>
        </div>
        <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.balanceLastChangedDate">
      <span class="f-20  white-text-block">
        {{accounts.selectedAccount.balanceLastChangedDate | date:'shortDate'}}</span>
          <span class="white-text-block" translate="accounts.accDateLastChanged"></span>
        </div>
        <div class="col-xs-6 col-md-4 p-b-20" ng-if="accounts.selectedAccount.limitValidUntilDate">
      <span class="f-20  white-text-block">
        {{accounts.selectedAccount.limitValidUntilDate | date:'shortDate'}}</span>
          <span class="white-text-block" translate="accounts.accLimitValidUntilDate"></span>
        </div>
        <div class="col-xs-6 col-md-4 p-b-20" ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != 'sl'">
        <span class="f-20 white-text-block"
              ng-if="accounts.selectedAccount.reservedAmount && !accounts.selectedAccount.planedDebit">{{accounts.selectedAccount.reservedAmount | number:2}} {{accounts.selectedAccount.currencySymbol}}</span>
          <span class="f-20 white-text-block" ng-if="accounts.selectedAccount.planedDebit">{{accounts.selectedAccount.planedDebit | number:2}} {{accounts.selectedAccount.currencySymbol}}</span>
          <span class="f-20 white-text-block"
                ng-if="!accounts.selectedAccount.reservedAmount && !accounts.selectedAccount.planedDebit">{{0 | number:2}} {{accounts.selectedAccount.currencySymbol}}</span>
          <span class="white-text-block" translate="accounts.accReservations"></span>
        </div>
      </div>
    </div>
  </div>
